import React, { useEffect, useState } from "react";
import {
  ControlDockHeader,
  AreaGenContainer,
} from "../styled/potree/PotreeControl.styles";
import { DeleteIcon, DownloadIcon } from "../../assets/icons/WorkTypeIcons";
import { deleteArea, getAreaById, getAreaList } from "../../api/cesiumAPI";
import {
  AreaGenerateIcon,
  PathGenerateIcon,
} from "../../assets/icons/WorkTypeIcons";
import {
  useCesiumStore,
  useCustomAlertStore,
  useAreaGenerateStore,
  useDownloadModalStore,
} from "../../Store/store";

export default function AreaSelect() {
  const [areaList, setAreaList] = useState([]);
  const { showWarningAlert } = useCustomAlertStore();
  const { setSelectedArea, loadedServerPolygon } = useAreaGenerateStore();
  const { clearAllPoints, stopRatationFunction } = useCesiumStore();
  const { openModal } = useDownloadModalStore();

  useEffect(() => {
    const fetchAreaList = async () => {
      const response = await getAreaList();

      setAreaList(response);
    };
    fetchAreaList();
  }, []);

  const handleDeleteArea = async (id) => {
    showWarningAlert(
      "영역 및 경로를 삭제하시겠습니까?",
      "지운 영역 및 경로는 복구할 수 없습니다.",
      async () => {
        const response = await deleteArea(id);
        const response2 = await getAreaList();
        setAreaList(response2);
      },
    );
  };

  const handleAreaSelect = async (id) => {
    stopRatationFunction();
    clearAllPoints();
    const response = await getAreaById(id);

    // setSelectedArea(response);
    loadedServerPolygon(response);
  };

  const handleDownloadClick = async (e, id) => {
    e.stopPropagation();

    const response = await getAreaById(id);

    openModal(response);
  };

  return (
    <AreaGenContainer>
      <section className="AreaSelectContainer">
        <ControlDockHeader>
          <h2>영역 목록</h2>
          <p>생성된 영역을 확인할 수 있습니다.</p>
        </ControlDockHeader>
        <main className="AreaSelectList">
          {areaList.map((area) => (
            <article
              className="AreaSelectItem"
              key={area.id}
              onClick={() => handleAreaSelect(area.id)}
            >
              <h3 className="AreaSelectItemTitle">{area.name}</h3>
              <p className="AreaSelectItemDescription selected">
                {area.createdAt}
              </p>
              <p className="AreaSelectItemDistance">
                <span>
                  {area.geometryType === "PATH"
                    ? area.value || 0
                    : area.value || 0}{" "}
                </span>
                {area.geometryType === "PATH" ? "km" : "km²"}
              </p>
              <button
                aria-label="삭제"
                className="AreaSelectItemDeleteButton"
                onClick={() => handleDeleteArea(area.id)}
              >
                <DeleteIcon size={16} />
              </button>
              <div className="AreaSelectItemIcon">
                <button
                  aria-label="다운로드"
                  className="AreaSelectItemDownloadButton"
                  onClick={(e) => handleDownloadClick(e, area.id)}
                >
                  <DownloadIcon size={20} color="#00ff99" /> 다운로드
                </button>
                {area.geometryType === "PATH" ? (
                  <PathGenerateIcon size={20} color="#b6b6b6" />
                ) : (
                  <AreaGenerateIcon size={20} color="#b6b6b6" />
                )}
              </div>
            </article>
          ))}
        </main>
      </section>
    </AreaGenContainer>
  );
}
